import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MEDIA from 'compositions/helpers/mediaTemplates';
import { CTA, Image } from 'lib/index';
import { COLORS } from 'compositions/constants/constants';

const MediaBlock = props => {
  const BoxWrapper = styled.div`
    width: 100%;
    padding: 16px;
    border: 1px solid ${COLORS.grayLight};
    h2 {
      margin: 0;
    }
    div {
      margin-bottom: 16px;
    }
    ${MEDIA.MIN_TABLET`
      width: 300px;
    `};
  `;
  const ImageBlock = props.source ? (
    <Image source={props.source} alt={props.altText} />
  ) : (
    <Image />
  );
  const CTABlock = (
    <CTA type="secondary" target={props.ctaTarget} href={props.ctaHref}>
      {props.ctaText}
    </CTA>
  );
  return (
    <BoxWrapper>
      <div>
        <h2>{props.heading}</h2>
      </div>
      <div>{ImageBlock}</div>
      <div>{props.copy}</div>
      <div>{CTABlock}</div>
    </BoxWrapper>
  );
};

MediaBlock.propTypes = {
  /** Content (accepted via string or components / DOM nodes) */
  children: PropTypes.node,
  /** Heading */
  heading: PropTypes.string,
  source: PropTypes.string,
  altText: PropTypes.string,
  copy: PropTypes.string,
  ctaText: PropTypes.string,
  ctaTarget: PropTypes.string,
  ctaHref: PropTypes.string,
};

export default MediaBlock;
